﻿function sprintf(text) {
    if (!text || !text.length) {
        return null;
    }

    const args = [].slice.call(arguments, 1);
    return text.replace(/{(\d+)}/g,
        function(match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match;
        });
}

export { sprintf }
